import { getTenant } from '@api/tenantApi';
import { Tenant } from '@api/tenantApi/interfaces';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export const useGetTenant = () => {
  return useQuery<Tenant>({
    queryFn: () => getTenant(),
    queryKey: ['tenant'],
    staleTime: Infinity,
    retry: (failureCount, error) => {
      if ((error as AxiosError)?.response?.status === 404) {
        return false;
      }

      return failureCount < 3;
    },
  });
};
